export default "__VITE_ASSET__B8Z8RyoR__"